import {doRequest} from '../../helpers/network';
import {DeltaAnnexure} from '../../helpers/Urls';
import {REQUEST_TYPE} from '../../constants';

export const GET_DELTA_ANNEX_INITIAL_DATA = 'GET_DELTA_ANNEX_INITIAL_DATA';
export const GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED =
  'GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED';
export const GET_DELTA_ANNEX_INITIAL_DATA_FAILED =
  'GET_DELTA_ANNEX_INITIAL_DATA_FAILED';

export const SEARCH_DELTA_ANNEXURES_DETAILS = 'SEARCH_DELTA_ANNEXURES_DETAILS';
export const SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED =
  'SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED';
export const SEARCH_DELTA_ANNEXURES_DETAILS_FAILED =
  'SEARCH_DELTA_ANNEXURES_DETAILS_FAILED';

export const PRINT_DELTA_ANNEXURE = 'PRINT_DELTA_ANNEXURE';
export const PRINT_DELTA_ANNEXURE_COMPLETED = 'PRINT_DELTA_ANNEXURE_COMPLETED';
export const PRINT_DELTA_ANNEXURE_FAILED = 'PRINT_DELTA_ANNEXURE_FAILED';

export const VIEW_REGULARISED_ANNEXURE = 'VIEW_REGULARISED_ANNEXURE';
export const VIEW_REGULARISED_ANNEXURE_COMPLETED =
  'VIEW_REGULARISED_ANNEXURE_COMPLETED';
export const VIEW_REGULARISED_ANNEXURE_FAILED =
  'VIEW_REGULARISED_ANNEXURE_FAILED';

export const COMMENT_DELTA_ANNEXURE = 'COMMENT_DELTA_ANNEXURE';
export const COMMENT_DELTA_ANNEXURE_COMPLETED =
  'COMMENT_DELTA_ANNEXURE_COMPLETED';
export const COMMENT_DELTA_ANNEXURE_FAILED = 'COMMENT_DELTA_ANNEXURE_FAILED';

export const SAVE_DELTA_BILL_DETAILS = 'SAVE_DELTA_BILL_DETAILS';
export const SAVE_DELTA_BILL_DETAILS_COMPLETED =
  'SAVE_DELTA_BILL_DETAILS_COMPLETED';
export const SAVE_DELTA_BILL_DETAILS_FAILED = 'SAVE_DELTA_BILL_DETAILS_FAILED';

const CLEAR_SEARCH_DELTA_ANNEXURES_DATA = 'CLEAR_SEARCH_DELTA_ANNEXURES_DATA';
const RESET_PAGE = 'RESET_PAGE';

const initialState = {
  isFetching: false,
  error: false,
  hasError: false,
  resetPage: false,
  annexuresData: {},
  requestingCommentAnnex: false,
  requestingNextAnnex: false,
  uploadingRevBill: false,
  savingDeltaBillDetails: false,
  annexureInfo: {},
  currentTripRejectData: {},
  deletingAnnex: false,
  isRequestingAnnexure: false,
  printingDeltaAnnex: false,
  updatingRev: false,
  updatingCostRev: false,
  updatingOthers: false,
  sendingForAnnexApproval: false,
  approvingAnnex: false,
  rejectingAnnex: false,
  deletingTripsAnnexure: true,
};

export const getDeltaAnnexInitialData = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_DELTA_ANNEX_INITIAL_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.getDeltaAnnexInitialDataURL(),
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_DELTA_ANNEX_INITIAL_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_DELTA_ANNEX_INITIAL_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const searchDeltaAnnexuresData = (
  requestData = {},
  page,
  resetPage = true,
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEARCH_DELTA_ANNEXURES_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.searchDeltaAnnexuresDataURL(page),
        data: requestData,
      });
      const {data, status} = response || {};
      if (resetPage) {
        dispatch({type: RESET_PAGE});
      }
      if (status === true) {
        dispatch({
          type: SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SEARCH_DELTA_ANNEXURES_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEARCH_DELTA_ANNEXURES_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const clearSearchDeltaAnnexuresData = () => (dispatch) => {
  dispatch({
    type: CLEAR_SEARCH_DELTA_ANNEXURES_DATA,
  });
};

export const commentDeltaAnnexure = (annexureId, requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: COMMENT_DELTA_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.commentDeltaAnnexureURL(annexureId),
        data: requestData,
      });
      console.log('response --COMMENT_DELTA_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: COMMENT_DELTA_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: COMMENT_DELTA_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: COMMENT_DELTA_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const printDeltaAnnexure = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: PRINT_DELTA_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.printDeltaAnnexureURL(annexureId),
      });
      console.log('response --PRINT_DELTA_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: PRINT_DELTA_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: PRINT_DELTA_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: PRINT_DELTA_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const viewRegularisedAnnexure = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: VIEW_REGULARISED_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.viewRegularisedAnnexureURL(annexureId),
      });
      console.log('response --VIEW_REGULARISED_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: VIEW_REGULARISED_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: VIEW_REGULARISED_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: VIEW_REGULARISED_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveDeltaBillDetails = (annexureId, requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_DELTA_BILL_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.saveDeltaBillDetailsURL(annexureId),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SAVE_DELTA_BILL_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SAVE_DELTA_BILL_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_DELTA_BILL_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;

  let statePresent = state && Object.keys(state).includes('annexuresData');
  const {annexures} = statePresent && state?.annexuresData;
  let updateAnnx;
  switch (type) {
    case SEARCH_DELTA_ANNEXURES_DETAILS:
      return {
        ...state,
        isFetching: true,
      };
    case SEARCH_DELTA_ANNEXURES_DETAILS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: payload.error,
        hasError: true,
      };
    case SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED:
      return {
        ...state,
        isFetching: false,
        error: '',
        hasError: false,
        annexuresData: {...payload},
      };
    case CLEAR_SEARCH_DELTA_ANNEXURES_DATA:
      return {
        ...state,
        annexuresData: {},
      };
    case COMMENT_DELTA_ANNEXURE:
      return {
        ...state,
        requestingCommentAnnex: true,
      };
    case COMMENT_DELTA_ANNEXURE_FAILED:
      return {...state, requestingCommentAnnex: false};
    case COMMENT_DELTA_ANNEXURE_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresDataComment = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };

      return {
        ...state,
        requestingCommentAnnex: false,
        annexuresData: annexuresDataComment,
      };
    case PRINT_DELTA_ANNEXURE:
      return {
        ...state,
        printingDeltaAnnex: true,
      };
    case PRINT_DELTA_ANNEXURE_COMPLETED:
      return {
        ...state,
        printingDeltaAnnex: false,
      };
    case PRINT_DELTA_ANNEXURE_FAILED:
      return {
        ...state,
        printingDeltaAnnex: false,
      };
    case SAVE_DELTA_BILL_DETAILS:
      return {
        ...state,
        savingDeltaBillDetails: true,
      };
    case SAVE_DELTA_BILL_DETAILS_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            // ...annexures[curr].basicInfo,
            // bill_number: payload.annexures[curr].basicInfo.bill_number,
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresBillNumberChange = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };

      return {
        ...state,
        savingDeltaBillDetails: false,
        annexuresData: annexuresBillNumberChange,
      };
    case SAVE_DELTA_BILL_DETAILS_FAILED:
      return {
        ...state,
        savingDeltaBillDetails: false,
      };
    case GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED: {
      return {
        ...state,
        annexData: payload,
      };
    }
    // case RESET_PAGE:
    //   return {...state, resetPage: !state.resetPage};
    default: {
      if (payload.trips) {
        return {...state, ...payload.trips};
      }
      return state;
    }
  }
};
